import { ValidatorFunction } from '../../interface/validator-function.type';
import {isValidVimeoUrl} from '../url/is-valid-vimeo-url.util';

export const vimeoUrlValidator: (errorMessage: string, messageProps?: string[]) => ValidatorFunction = (errorMessage: string) => (data) => [{
  isValid: isValidVimeoUrl(data),
  messageKey: errorMessage || 'vimeo-url.invalid'
}];